<div #mapContainer class="map-container">
  <div class="flotante">
    <div class="row-flex-start" style="gap: 8px; margin-left: 0.3em">
      @if (dibujar.includes('LineString')) {
        @if (!dibujando && (!lineString.length || lineString.length === 0)) {
          <button
            irxBotonIcono="mapa"
            tono="primario"
            type="button"
            (click)="dibujarLineString()"
            tooltip="Dibujar recorrido"
          >
            <mat-icon>timeline</mat-icon>
          </button>
        }
        @if (dibujando) {
          <button
            irxBotonIcono="mapa"
            tono="peligro"
            type="button"
            (click)="parar()"
            tooltip="Pausar dibujo"
          >
            <mat-icon>pause</mat-icon>
          </button>
        }
        @if (!dibujando && lineString.length > 1) {
          <button
            irxBotonIcono="mapa"
            tono="peligro"
            type="button"
            (click)="continuar()"
            tooltip="Continuar dibujando"
          >
            <mat-icon>play_arrow</mat-icon>
          </button>

          <button
            irxBotonIcono="mapa"
            tono="peligro"
            type="button"
            (click)="snapToRoad()"
            tooltip="Ajustar a calles"
          >
            <mat-icon>edit_road</mat-icon>
          </button>
        }

        <button
          irxBotonIcono="mapa"
          tono="peligro"
          type="button"
          (click)="eliminarUltimaCoordenada()"
          tooltip="Eliminar último punto"
        >
          <mat-icon>undo</mat-icon>
        </button>

        <button
          irxBotonIcono="mapa"
          tono="peligro"
          type="button"
          (click)="borrar()"
          tooltip="Borrar todo"
        >
          <mat-icon>delete</mat-icon>
        </button>
      }
    </div>
  </div>

  @if (this.indicaciones.length > 0) {
    <div class="indicaciones magico-85">
      <div class="column-flex-start" style="width: 100%; gap: 5px">
        @for (i of this.indicaciones; track $index) {
          <span class="texto disable-text-selection">
            {{ i }}
          </span>
        }
      </div>
    </div>
  }
</div>
